import Header from "components/layout/Header";
import BookingForm from "./sections/BookingForm";
import Banner from "./sections/Banner";
import BackgroundImage from "./sections/bgImage/BackgroundImage";
import { useEffect, useRef, useState } from "react";
import Footer from "components/layout/Footer";
import { StorageUtils } from "utils/storageUtils";
import { ProviderUtils } from "utils/providerUtils";
import history from "history/browser";
import { closeWebview } from "utils/lottecardUtils";
import { closeHanpassWebView, isHanpassApp } from "utils/hanpassUtils";
import { useAppDispatch } from "app/hooks";
import { deleteMyOrders, resetFilterSetting } from "app/myOrdersSlice";
import LachaRewardBanner from "./sections/LachaRewardBanner";
import CardLayout from "components/layout/CardLayout";
import { useNavigate } from "react-router-dom";
import AttractionsIcon from "@mui/icons-material/Attractions";
import { __STAGING__ } from "const/properties";
import useModalSheet from "../../../hooks/overlay/useModalSheet";
import AuthService from "../../../services/authService";
import useReduxUtils from "../../../hooks/useReduxUtils";
import LottecardServiceEnded from "components/lottecard/LottecardServiceEnded";
import { isLottecardKtxReservationEnded } from "utils/lottecardServicePolicy";

const HomePage = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isChecking, setIsChecking] = useState(true);
  const { resetStore } = useReduxUtils({ retainToken: true });
  const hasResetStoreForLoggedOut = useRef(false);

  const [NoticeModal] = useModalSheet({
    defaultVisible: sessionStorage.getItem("NoticeModalRead") !== "true",
    callbackOk: () => {
      sessionStorage.setItem("NoticeModalRead", "true");
    },
  });

  // // 코레일 작업 완료 일정
  const maintenanceEndTime = new Date(2025, 5, 14, 0, 0);
  const isMaintenanceDone = new Date() > maintenanceEndTime;
  const isLottecardServiceEnded = isLottecardKtxReservationEnded();

  useEffect(() => {
    const checkLoggedIn = async () => {
      if (!isChecking) {
        return;
      }
      const response = await AuthService.isLoggedIn();
      setIsLoggedIn(response);
      setIsChecking(false);
    };
    checkLoggedIn();

    dispatch(deleteMyOrders());
    dispatch(resetFilterSetting());

    StorageUtils.TrainTab.remove();
    StorageUtils.ScrollY.remove();
  }, [dispatch]);

  useEffect(() => {
    if (isChecking) return;

    if (isLoggedIn) {
      hasResetStoreForLoggedOut.current = false;
      return;
    }

    if (hasResetStoreForLoggedOut.current) return;

    console.log("로그아웃 상태입니다!");
    hasResetStoreForLoggedOut.current = true;
    resetStore();
  }, [isChecking, isLoggedIn, resetStore]);

  useEffect(() => {
    // navigate(window.location.pathname); 이 코드 있으면 안 됨 - url 복붙 하면 / 로 이동함

    let isClosing = false;

    const listenBackEvent = (reason: "history-pop" | "window-popstate") => {
      if (isClosing) return;

      if (ProviderUtils.isHanpass) {
        isClosing = true;
        StorageUtils.HanpassBack.remove();
        closeHanpassWebView();
        return;
      }
      if (ProviderUtils.isLottecard) {
        isClosing = true;
        closeWebview();
      }
    };

    if (ProviderUtils.isHanpass && !isHanpassApp() ) {
      const state = window.history.state as
        | (Record<string, unknown> & { __hanpassBackTrap?: boolean })
        | null;

      if (!state?.__hanpassBackTrap) {
        window.history.pushState(
          {
            ...(state ?? {}),
            __hanpassBackTrap: true,
          },
          "",
          window.location.href
        );
      }
    }

    const popStateHandler = () => {
      listenBackEvent("window-popstate");
    };
    window.addEventListener("popstate", popStateHandler);

    const historyEvent = history.listen(({ action }) => {
      if (action === "POP") {
        listenBackEvent("history-pop");
      }
    });

    return () => {
      historyEvent();
      window.removeEventListener("popstate", popStateHandler);
      // window.history.replaceState(null, "");
    };
  }, []);

  return (
    <>
      <Header />

      {isLottecardServiceEnded ? (
        <LottecardServiceEnded />
      ) : (
        <>
          <BackgroundImage />

          <section className="relative mx-auto mb-20 min-h-[80vh] max-w-md space-y-4 px-4">
            <BookingForm />

            {__STAGING__ && (
              <CardLayout>
                <div
                  className="flex items-center justify-center gap-2"
                  onClick={() => {
                    navigate("/activity");
                  }}
                >
                  <AttractionsIcon color="primary" className="!text-5xl" />
                  <p className="text-xl font-bold text-text-secondary">
                    일본 여행 상품 예약하기
                  </p>
                </div>
              </CardLayout>
            )}

            {/* <LachaRewardBanner /> */}

            {/* {ProviderUtils.provider?.provider !== "lottecard" && <Banner />} */}
          </section>
        </>
      )}

      {!isLottecardServiceEnded && !isMaintenanceDone && (
        <NoticeModal modal>
          <div className="space-y-4 text-center leading-relaxed">
            <p className="font-bold">
              [공지]전국철도노동조합 파업 예고에 따른 안내
            </p>

            <p>
              전국철도노동조합이<br />
              <strong>2025년 12월 11일(목) 09시부터</strong><br />
              파업을 예고하고 있습니다.
            </p>

            <p>
              <strong>노사교섭이 결렬되어 파업에 돌입할 경우</strong><br />
              일부 KTX 및 일반열차<br />
              <strong>운행이 중지될 예정입니다.</strong>
            </p>

            <p>
              열차 이용 전에<br />
              <strong>
                코레일톡, 홈페이지 등에서<br />
                열차운행 여부를 확인
              </strong>하시기 바랍니다.
            </p>

            <p className="text-red-600 text-sm">
              ※ 파업기간 운행중지 열차 승차권 환불 시<br />
              위약금은 발생하지 않습니다.
            </p>
          </div>
        </NoticeModal>
              )}

      <Footer />
    </>
  );
};

export default HomePage;
